import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import RegularButton from "@components/buttons/RegularButton";
import { ProgressOverlay } from "@common/ProgressOverlay";

type Props = {
  open: boolean;
  onClose: () => void;
  onConsultant: () => void;
  onCustomer: () => void;
  loading?: boolean;
};

export const ChooseEmailDialog = (props: Props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{locale.SendTo}</DialogTitle>

      <DialogContent style={{ overflow: "auto" }}>
        {props.loading && <ProgressOverlay />}
        <Box display={"flex"} justifyContent={"space-between"} style={{ gap: 10 }}>
          <Button
            variant={"contained"}
            fullWidth
            color={"secondary"}
            onClick={props.onConsultant}
          >
            {locale.Consultant}
          </Button>

          <Button
            variant={"contained"}
            fullWidth
            color={"secondary"}
            onClick={props.onCustomer}
          >
            {locale.Customer}
          </Button>
        </Box>
      </DialogContent>

      <DialogActions>
        <RegularButton style={{ marginRight: "auto" }} onClick={props.onClose}>
          {locale.Cancel}
        </RegularButton>
      </DialogActions>
    </Dialog>
  );
};
